<template>
  <BadgeWrapper
    :text="showBadge ? '!' : null"
    :badgeMps="badgeMps"
    v-bind="$attrs"
  >
    <empty-image v-if="!urlImage" />
    <img
      v-else
      :src="urlImage"
      :style="{ width, height, objectFit: 'contain' }"
      :alt="alt || ''"
    />
  </BadgeWrapper>
</template>

<script setup lang="ts">
import EmptyImage from "@/components/common/EmptyImage.vue";
import BadgeWrapper from "@/components/UI/BadgeWrapper.vue";
import { computed } from "vue";
import { mediaUrl } from "../../../env.d.ts";
import { type MarketPlacesEnum as MarketPlacesEnumType } from "@/types/types";

const {
  url,
  showBadge,
  badgeMps,
  alt,
  width = "60px",
  height = "auto",
} = defineProps<{
  url: string | null;
  showBadge?: boolean;
  badgeMps?: MarketPlacesEnumType[];
  alt?: string;
  width?: string;
  height?: string;
}>();

defineOptions({
  inheritAttrs: false,
});

const urlImage = computed(() => {
  if (url) {
    return url.includes("http") ? url : `${mediaUrl}/${url}`;
  }

  return "";
});
</script>

<style scoped></style>
